<template>
  <div class="row">
    <div class="tab-bar start" :class="{'hidden-xs hidden-sm':isShowWeb}">
      <div class="tab-bar-icon" @click="goIndex">
        <!-- <img src="@/images/logo.png" alt="#" class="bar-icon-img" /> -->
        <img :src="imgUrl + settingsInfo.app_logo" alt="#" class="bar-icon-img" />
      </div>
      <div class="tab-bar-center spaceBetween">
        <div class="bar-center-middle start">

          <div class="center-middle-list start" @click="goJoinCBH">
            <span class="middle-list-font">{{lanType==1?'加入CBH':'Join Us'}}</span>
          </div>

          <div class="center-middle-list start" v-on:click="showIndex(2)">
            <span class="middle-list-font">{{lanType==1?'项目':'Program'}}</span>
            <img src="@/images/down.png" alt="#" class="middle-list-icon" />
            <div class="middle-list-layer" v-if="index==2">
              <span class="caret list-layer-icon"></span>
              <div class="list-layer-li" v-for="(item,index) in projectList" :key="index" @click="goChance(item)">{{lanType==1?item.title:item.titleEn}}</div>
              <!-- <div class="list-layer-li">RE买家联盟</div>
              <div class="list-layer-li">气候创行者</div> -->
            </div>
          </div>

          <div class="center-middle-list start" @click="goDynamic">
            <span class="middle-list-font">{{lanType==1?'新闻动态':'Updates'}}</span>
            
          </div>

          <div class="center-middle-list start" @click="goActivity">
            <span class="middle-list-font">{{lanType==1?'活动':'Activity'}}</span>
            
          </div>

          <div class="center-middle-list start" @click="goPublication">
            <span class="middle-list-font">{{lanType==1?'出版物':'Publications'}}</span>
          </div>

          <!-- <div class="center-middle-list start" @click="goEnterprise">
            <span class="middle-list-font">{{lanType==1?'企业碳自查工具':'GreenDev'}}</span>
          </div> -->
        </div>

        <div class="bar-center-right end">
          <div class="center-right-search middle">
            <img :src="showLayer?deleteImg:searchImg" alt="#" @click="choiceSearch" class="right-search-img" />
          </div>
          
          <div class="center-right-lan start" @click="showLayerBtn('login')" v-if="!isLogin">
            <img src="@/images/register.png" alt="#" class="right-lan-img"/>
            <div class="center-right-btn middle">{{lanType==1?'登录':'LogIn'}}</div>
          </div>
          <div class="center-right-lan start" @click="showLayerBtn('user')" v-if="!isLogin">
            <img src="@/images/login.png" alt="#" class="right-lan-img"/>
            <div class="center-right-btn middle">{{lanType==1?'注册':'Register'}}</div>
          </div>
          <!-- v-if="isLogin" -->
          <div class="center-right-lan start" @click="logoutBtn" v-if="isLogin">
            <!-- <img src="@/images/login.png" alt="#" class="right-lan-img"/> -->
            <div class="center-right-btn middle">{{userInfo.email}}</div>
            <div class="center-right-btn middle right-btn-real">{{lanType==1?'退出':'Sign out'}}</div>
          </div>

          <div class="center-right-lan start" style="display:none">
            <div class="center-right-btn" :class="{'color1':lanType==2}" @click="choiceLan(2)">EN</div>
            <div class="right-btn-line"></div>
            <div class="center-right-btn" :class="{'color1':lanType==1}" @click="choiceLan(1)">CN</div>
          </div>
        </div>
      </div>
    </div>
    <div style="width:100%;height:0.5rem;" :class="{'hidden-xs hidden-sm':isShowWeb}"></div>
    <div class="input-layer" v-if="showLayer">
      <div class="input-layer-center start">
        <img src="@/images/search.png" alt="#" class="layer-center-img" style="width:20px;height:20px;"/>
        <input v-model="search" v-on:keyup.13="submit" type="text" class="layer-center-input" :placeholder="lanType==1?'请输入要搜索的内容':'Please enter the content to search'" />
      </div>
    </div>

    <div class="phone-tab-bar hidden-md hidden-lg spaceBetween" v-if="isShowWeb">
      <div class="phoen-bar-icon">
        <img :src="imgUrl + settingsInfo.app_logo" alt="#" class="phoen-icon-img" />
      </div>

      <div class="phoen-bar-center end" v-on:click="isPhone=true">
        <img src="@/images/menu.png" alt="#" class="phoen-bar-img" />
      </div>
    </div>
    <div class="phone-tab-bar-line hidden-md hidden-lg" v-if="isShowWeb"></div>

    <div class="phone-tab-center" v-if="isPhone">
      <div class="phone-center-top" v-on:click="isPhone=false">
        <div class="phone-top-list start">
          <img src="@/images/phoneIcon.png" alt="#" class="phoen-bar-img" />
        </div>
      </div>

      <div class="tab-center-middle">

        <div class="phone-center-list">
          <div class="center-list-top start" v-on:click="showIndex(2)">
            <span class="phone-list-font">{{lanType==1?'项目':'Program'}}</span>
            <img src="@/images/downIcon.png" alt="#" class="phone-list-icon" />
          </div>
          <div class="phone-list-ul" v-if="index==2">
            <div class="list-ul-li" v-for="(item,index) in projectList" :key="index" @click="goChance(item)">{{lanType==1?item.title:item.titleEn}}</div>
            
          </div>
        </div>

        <div class="phone-center-list">
          <div class="center-list-top start"  @click="goDynamic">
            <span class="phone-list-font">{{lanType==1?'新闻动态':'Updates'}}</span>
            <!-- <img src="@/images/down.png" alt="#" class="phone-list-icon" /> -->
          </div>
        </div>

        <div class="phone-center-list">
          <div class="center-list-top start" @click="goActivity">
            <span class="phone-list-font">{{lanType==1?'活动':'Activity'}}</span>
            <!-- <img src="@/images/down.png" alt="#" class="phone-list-icon" /> -->
          </div>
        </div>

        <div class="phone-center-list">
          <div class="center-list-top start" @click="goPublication">
            <span class="phone-list-font">{{lanType==1?'出版物':'Publications'}}</span>
            <!-- <img src="@/images/down.png" alt="#" class="phone-list-icon" /> -->
          </div>
        </div>

        <!-- <div class="phone-center-list">
          <div class="center-list-top start" @click="goJoinCBH">
            <span class="phone-list-font">{{lanType==1?'加入CBH':'JoinUs'}}</span>
          </div>
        </div> -->

        <!-- <div class="phone-center-list">
          <div class="center-list-top start" @click="goEnterprise">
            <span class="phone-list-font">{{lanType==1?'企业碳自查工具':'GreenDev'}}</span>
          </div>
        </div> -->

        <!-- <div class="phone-center-btn middle">熊猫客</div> -->

        <div class="phone-center-input spaceBetween">
          <input type="text" v-model="search" @blur="submit" class="phone-input-real form-control"/>
          <img src="@/images/searchBark.png" alt="#" class="phone-input-icon"/>
        </div>

        <div class="phone-center-bottom spaceBetween" v-if="!isLogin">
          <div class="center-bottom-list start" @click="showLayerBtn('user')" >
            <img src="@/images/phoneUser.png" alt="#" class="bottom-list-li">
            <div class="bottom-list-font">{{lanType==1?'注册':'Register'}}</div>
          </div>
          <div class="center-bottom-list end" @click="showLayerBtn('login')">
            <img src="@/images/phoneLogin.png" alt="#" class="bottom-list-li">
            <div class="bottom-list-font">{{lanType==1?'登录':'Log in'}}</div>
          </div>
        </div>

        <div class="phone-center-bottom spaceBetween" @click="logoutBtn" v-if="isLogin">
          <div class="center-right-btn middle" style="color:#fff;font-size:0.32rem;">{{userInfo.email}}</div>
          <div class="center-right-btn middle right-btn-real">{{lanType==1?'退出':'Sign out'}}</div>
        </div>

        <div class="phone-center-bottom start" style="display:none">
            <div class="phone-list-font" :class="{'color1':lanType==2}" @click="choiceLan(2)">EN</div>
            <div class="right-btn-line" style="background:#fff;margin-right: 8px;height: 0.2rem;"></div>
            <div class="phone-list-font" :class="{'color1':lanType==1}" @click="choiceLan(1)">CN</div>
          </div>
      </div>
    </div>

    <user ref="users"></user>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import searchImg from '@/images/search.png';
import deleteImg from '@/images/delete.png';
import user from './user.vue';
import config from '@/utils/config';
import { userInfo } from 'os';
export default {
  name: 'tab',
  components: {
    user:user
  },
  data () {
    return {
      isPhone:false,
      index:null,
      listTab:[],
      showLayer:false,
      deleteImg:deleteImg,
      searchImg:searchImg,
      search:'',
      projectList:[],
      isLogin:false,
      isShowWeb:config.urlList.isShowWeb,
      imgUrl: config.urlList.imgUrl,
      userInfo:{},
      token:'',
      settingsInfo: {},
      lanType:1 // 1中文 2英文
    }
  },
  methods:{
    
    setSearch(str){
      const vm=this
      vm.search=str
    },
    login(token){
      const vm=this;
      vm.isLogin=true;
      vm.token=token;
      vm.queryUerInfo(token);
    },
    queryUerInfo(token){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/userinfo?token=${token}`).then(res => {
        if(res.data.code==1){
          vm.userInfo=res.data.data
          localStorage.setItem('CbhuserInfo', JSON.stringify(vm.userInfo));
          //this.$router.go(0);
        }else{
          vm.logoutBtn()
        }
      })
    },
    logoutBtn(){
      const vm=this
      let arr=vm.projectList;
      localStorage.setItem('Cbhtoken', '');
      localStorage.setItem('CbhuserInfo', {});
      vm.isLogin=false;
      axios.post(`${config.urlList.queryUrl}/api/cbh/logout?token=${vm.token}`).then(res => {
        if(res.data.code==1){
          vm.isLogin=false;
          vm.$router.go(0);
        }
      })
    },
    submit(){
      const vm=this
      
    },
    showLayerBtn(type){
      const vm=this;
      vm.isPhone=false;
      vm.$refs.users.showLayerBtn(type);
    },
    goIndex(){
      const vm=this
      vm.$router.push({ path:'/'  })
    },
    goDynamic(){
      const vm=this
      vm.$router.push({ path:'/news'})
    },
    goPublication(){
      const vm=this
      vm.$router.push({ path:'/publication'  })
    },
    goJoinCBH(){
      const vm=this
      vm.$router.push({ path:'/joinCBH'  })
    },
    goMechanism(){
      const vm=this
      vm.$router.push({ path:'/mechanism'  })
    },
    goActivity(){
      const vm=this
      vm.$router.push({ path:'/activity'  })
    },
    goEnterprise(){
      const vm=this
      if(vm.token){
        let url = 'https://tgj.greendev.org.cn/home/redirectLoginWwf?token=' + vm.token
        window.open(url)
      }else{
        alert('您尚未登录/注册。请先点击右上角，登录/注册成功后再使用工具。');
        // vm.$toast({
        //   text: '请登录后再试！',
        //   type: 'danger',
        //   duration: 1600
        // })
      }
    },
    goChance(item){
      const vm=this
      if(item.id==2){
        vm.$router.push({ path:'/RE'})
        return
      }
      if(item.id==1){
        vm.$router.push({ path:'/sbti'})
        return
      }
      if(item.id==3){
        vm.$router.push({ path:'/climatesolver'})
        return
      }
      if(item.id==4){
        vm.$router.push({ path:'/fuel'})
        return
      }
      if(vm.$route.name=='chance'){
        let obj={
          id:item.id
        }
        vm.$parent.queryPage(obj);
      }
      vm.$router.push({ path:'/projectDetail',query:{id:item.id}  })

      // if(item.id==1||item.id==2){
      //   if(vm.$route.name=='chance'){
      //     let obj={
      //       id:item.id
      //     }
      //     vm.$parent.queryPage(obj);
      //   }
      //   vm.$router.push({ path:'/chance',query:{id:item.id}  })
      // }else if(item.id==3){
      //   window.open('http://climatesolver.wwfchina.org/')
      // }else{
      //   vm.$router.push({ path:'/joinCBH'})
      // }
    },
    showIndex(num){
      const vm=this
      vm.index=vm.index==num?null:num;
    },
    choiceSearch(){
      const vm=this;
      vm.showLayer=!vm.showLayer;
    },
    setTitle(da){
      const vm=this
      if(da.titleEn){
        return da
      }
      switch (da.title) {
        case '科学碳目标':
          da.titleEn = "Science Based Target initiative (SBTi)";
          break;
        case '科学碳目标简介':
          da.titleEn = "Introduction";
          break;
        case '设置科学碳目标':
          da.titleEn = "Setting SBTi";
          break;
        case '案例':
          da.titleEn = "Best practice";
          break;
        case '活动':
          da.titleEn = "Events";
          break;
        case '绿色电力需求行动':
          da.titleEn = "China Corporate Renewable Energy Program";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.titleEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.titleEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.titleEn = "Corporate RE Pilot Project";
          break;
        case '活动':
          da.titleEn = "Events";
          break;
        case '气候创行者':
          da.titleEn = "Climate Solver";
          break;
        case '气候创行者简介':
          da.titleEn = "Introduction";
          break;
        case '加入CBH':
          da.titleEn = "JoinUs";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.titleEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.titleEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.titleEn = "Corporate RE Pilot Project";
          break;
        case '企业气候行动共同体邀请函':
          da.titleEn = "CBH invitation letter";
          break;
        case '企业共同体组织机制':
          da.titleEn = "CBH Organization mechanism";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '联系方式':
          da.titleEn = "Contact information";
          break;
        default: 
          da.titleEn = da.title;
      }
      return da
    },
    queryProjectList(index){
      const vm=this
      let arr=vm.projectList
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/${index}`).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da=vm.setTitle(da)
          })
          vm.projectList=res.data.data
        }
      })
    },
    goActivityDetail(){
      const vm=this
      vm.$router.push({ path:'/activityDetail'})
    },
    choiceLan(type){
      const vm=this
      vm.lanType=type;
      Vue.config.lanType=type;
      localStorage.setItem('typenNum', type);
      vm.$parent.fatherMethod(type);
      if(vm.$refs.users){
        vm.$refs.users.choiceLanType(type);
      }
      let str = type==1?Vue.config.keyword.seo_keyword:Vue.config.keyword.seo_keyword_en
      document.title = vm.$route.meta.title+' ' + str
    },
    queryUserInfo(){
      const vm=this
      if(localStorage.getItem("Cbhtoken")){
        vm.login(localStorage.getItem("Cbhtoken"))
      }
    },
    querySettings(){
      const vm = this
      axios.get(
        `${config.urlList.queryUrl}/api/cbh/settings`,
      ).then(res => {
        if(res.data.code==1){
          vm.settingsInfo = res.data.data
          
        }
      })
    }
  },
  created () {
    const vm = this;
    vm.queryUserInfo();
    vm.queryProjectList();
    let num = localStorage.getItem("typenNum")||1
    vm.choiceLan(num);
    vm.querySettings()
    // if(localStorage.getItem('token')){
    //   vm.login(localStorage.getItem('token'))
    // }
  },
}
</script>

<style scoped>
/**  pc端导航样式  **/
.tab-bar{
  width: 100%;
  height: 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 9999;
}
.tab-bar-center{
  width: 100%;
  height: 0.5rem;
  background: #fff;
}
.tab-bar-icon{
  margin-left: 1rem;
  height: auto;
  width: 1.65rem;
}
.bar-icon-img{
  width: 100%;
  height: auto;
  cursor: pointer;
}
.bar-center-middle{
  margin-left: 0.5rem;
  width: auto;
  height: 0.32rem;
}
.center-middle-list{
  margin-right: 0.20625rem;
  height: 0.32rem;
  position: relative;
  cursor: pointer;
}
.middle-list-layer{
  position: absolute;
  top: 0.47rem;
  left: 50%;
  transform: translateX(-50%);
  width: 1.3rem;
  height: auto;
  background: #ffffff;
  border-radius: 4px;
  z-index: 9999;
  /* position: relative; */
}
.middle-list-layer::before{
  content: "";
  display: block;
  left: 0;
  right: 0;
  top: 0;
  height: 4px;
  background: #49bc9b;
}
.list-layer-icon{
  position: absolute;
  top: -4px;
  left: 40%;
  transform:rotate(180deg);
  border-top-color: #fff;
}
.list-layer-li{
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.1rem;
  color: #333;
  border-bottom: 1px solid #fafafa;
  font-family: 'wwf'
}
.list-layer-li:last-child{
  border-bottom: none;
}
.middle-list-font{
  font-size: 0.13rem;
  color: #333;
  margin-right: 0.0875rem;
  font-family: 'wwf';
}
.center-right-btn{
  font-size: 0.13rem;
  color: #333;
  font-family: 'wwf';
}
.middle-list-icon{
  width: 0.08125rem;
  height: 0.05rem;
}
.center-right-search{
  width: 0.425rem;
  height: 0.35rem;
  border-left: 1px solid #ededed;
  border-right: 1px solid #ededed;
  cursor: pointer;
}
.right-search-img{
  width: 0.125rem;
  height: 0.125rem;
}
.bar-center-right{
  padding-right: 1rem;
}
.center-right-lan{
  margin-left: 0.21875rem;
  cursor: pointer;
}
.right-btn-line{
  width: 1px;
  height: 0.1rem;
  background: #333;
  margin: 0 6px;
}
.right-lan-img{
  width: 0.125rem;
  height: 0.125rem;
  margin-right: 0.0625rem;
}

.input-layer{
  padding: 10px 30px;
  background: #fff;
  border-bottom: 1px solid #ddd;
}
.input-layer-center{
  height: 0.4375rem;
  margin-left: 1.2rem;
}
.layer-center-input{
  height: 100%;
  padding-left: 20px;
  flex: 2;
  font-size: 14px;
  color: #333;
  border: none;
  outline:none; 
  box-shadow: none;
}
.layer-center-input:focus{
  box-shadow: none;
  border: none;
}


/**  移动端导航样式  **/
.phone-tab-bar{
  height: 2.1rem;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 999;
}
.phone-tab-bar-line{
  height: 2.1rem;
  width: 100%;
}

.phoen-bar-center{
  width: 100%;
  height: 1.067rem;
  background: #fff;
}
.phoen-bar-icon{
  margin-left: 0.667rem;
  width: auto;
  height: auto;
}
.phoen-icon-img{
  width: auto;
  height: auto;
}

.phoen-bar-img{
  width: 0.533rem;
  height: 0.48rem;
  margin-right: 0.4rem;
}
/**  弹窗样式  **/
.phone-tab-center{
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 5.333rem;
  background: rgba(0,0,0,0.6);
  z-index: 9999999;
  overflow-y: hidden;
}
.phone-center-top{
  padding-left: 0.533rem;
  height: 1.5rem;
}
.tab-center-middle{
  width: 100%;
  height: calc(100vh - 1.5rem);
  overflow-y: auto;
  padding-bottom: 1rem;
}
.phone-top-list{
  width: 100%;
  height: 1.067rem;
}
.phone-center-list{
  padding-left: 0.533rem;
  height: auto;
  margin-bottom: 0.666rem;
  margin-bottom: 0.12rem;
}
.center-list-top{
  height: 1.2rem;
}
.phone-list-font{
  font-size: 0.346rem;
  color: #fff;
  font-weight: 600;
  margin-right: 0.24rem;
}
.phone-list-icon{
  width: 0.32rem;
  height: 0.187rem;
}
.phone-list-ul{
  padding-left:0.8rem;
  height: auto;
}
.list-ul-li{
  width: 100%;
  text-align: left;
  height: 0.906rem;
  line-height: 0.906rem;
  font-size: 0.32rem;
  color: #fff;
}
.phone-center-btn{
  margin: 0 0.533rem;
  height: 0.933rem;
  background: #cf6e32;
  font-size: 0.4rem;
  color: #333;
  margin-top: 0.8rem;
}
.phone-center-input{
  margin: 0.933rem 0.533rem 0;
  height: 0.8rem;
  background: #fff;
  border-radius: 6px;
}
.phone-input-real{
  flex: 2;
  height: 0.8rem;
  font-size: 0.187rem;
  color: #333;
  border-radius: 6px;
  border: none;
  box-shadow: none;
}
.phone-input-icon{
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 0.267rem;
  border-radius: 6px;
}
.form-control:focus{
  box-shadow: none;
}
.phone-center-bottom{
  margin-top: 0.4rem;
  height: auto;
  padding: 0 0.573rem;
  width: 100%;
}
.center-bottom-list{
  flex: 2;
  height: auto;
  padding-left: 0.1px;
}
.bottom-list-li{
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 0.1rem;
}
.bottom-list-font{
  font-size: 0.32rem;
  color: #fff;
}

.right-btn-real{
  background: #49bc9b;
  padding: 6px 12px;
  line-height: 1;
  border-radius: 4px;
  color: #fff;
  margin-left: 8px;
}
.color1{
  color: #49bc9b;
}
</style>
